export default {
  home: '/',
  artist: '/artist/:artistId',
  settings: '/settings',
  allStats: '/stats',
  history: '/history',
  login: '/login',
  logout: '/logout',
  register: '/register',
  activateSpotify: '/activate',
  topArtists: '/top/artists',
  topSongs: '/top/songs',
  topAlbums: '/top/albums',
};
